import { makeStyles } from '@material-ui/core/styles';

const componentHeight = '10px';
export const kkColor = 'rgba(37, 168, 148, 1)';
export const pzwoColor = 'rgba(60, 65, 154, 1)';
export const ZWOreadyColor = 'rgba(79, 167, 238, 1)';
export const totalColor = 'rgba(130, 92, 230, 1)';

export const useStyles = makeStyles(() => ({
  chart: {
    width: '100%',
    height: componentHeight,
    position: 'relative',
    '& *': {
      display: 'inline-block',
      height: componentHeight,
      position: 'absolute',
      borderRight: 'solid 1px white',
    },
  },
  kk: {
    borderRadius: '5px 0px 0px 5px',
  },
  pzwo: {
    borderRadius: '5px 0px 0px 5px',
  },
  zwoReady: {
    borderRadius: '5px 0px 0px 5px',
  },
  total: {
    borderRadius: '5px 5px 5px 5px',
  },
}));
